<script>
import { required } from "vuelidate/lib/validators";
import Customers from '@/services/Customers';
import Business from '@/services/Business'
import Multiselect from 'vue-multiselect';
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import _ from 'underscore';
import validationMessages from '@/components/validations'
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
export default {
  props: {
    modalData: {
      type: Object,
      default: () => ({}),
    },
  },
  components:{
    VueBootstrapTypeahead,
    validationMessages,
    vueDropzone: vue2Dropzone,
  },
  validations: {
    filterInput: {
        email: {
          required,
        },
        // company_role:{
        //   required,
        // },
        name:{
          required,
        },
        surname:{
          required,
        },
        // linkedin_url:{
        //   required,
        // },
        // image:{
        //   required,
        // }
    }
  },
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      source: 'dashboard',
      showModal: false,
      tryingToEdit: false,
      loadingExternalUsers: false,
      submitted: false,
      image_removed: false,
      file: null,
      image: "",
      photoDeletedCompanyImage:false,
      email : '',
      company_role:'',
      linkedin_url:'https://',
      title: "Customers",
      filterInput: {
        crm_user: "",
        name:"",
        company_role:"",
        email:"",
        surname:"",
        phone_number:"",
        linkedin_url:"https://",
        image:"",
        external_company_id: ''
      },
      externalUserData: [],
      selectedCompany:[],
      external_users: [],
      companyData:[],
      select_external_user: '',
      filter: null,
      isLoading: false,
      company_id:'',
      external_customer_id:'',
      externalUserSearch: '',
      externalUserNotFoundShow: false,
      dropzoneOptions_primary: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: true,
        thumbnailWidth: 200,
        thumbnailMethod: 'contain',
        maxFilesize: 5,
        acceptedFiles: 'image/jpeg,image/png,image/gif,image/bmp,image/webp',
        maxFiles: 3,
      },
    };
  },
  computed: {
      company() {
          return this.modalData && this.modalData.name ? this.modalData.name : '';
      }
  },
  watch: {
    'filterInput.crm_user': function(newVal) {
        this.filterInput.name = newVal && newVal.name ? newVal.name : '';
        this.filterInput.surname = newVal && newVal.surname ? newVal.surname : '';
        this.filterInput.email = newVal && newVal.email ? newVal.email : '';
        this.filterInput.phone_number = newVal && newVal.phone_number ? newVal.phone_number : '';
    },
    'externalUserSearch': _.debounce(function(search) { this.getUserExternalProvider(search, 'externalUserSearch') }, 1000),
  },

  methods: {

    async getUserExternalProvider(query) {
      this.isLoading = true;
      this.externalUserData = [];
      this.externalUserNotFoundShow = false
      this.external_customer_id = ''
      this.filterInput.name = ''
      this.filterInput.external_company_id = ''
      this.filterInput.surname = ''
      this.filterInput.email = ''
      this.filterInput.company_role = ''
      this.filterInput.linkedin_url = ''
      this.filterInput.phone_number = ''
      this.filterInput.linkedin_url = 'https://'

      if (query.length > 0) {

        try {
            const response = await Customers.getExternalMembers(`search=${this.externalUserSearch}&exclude_attached=true`)
            const rawData = response.data.data[0];
            if (rawData !== undefined && rawData !== null && rawData !== '') {
                this.external_customer_id = rawData.external_customer_id
                this.filterInput.name = rawData.name
                this.filterInput.external_company_id = rawData.external_company_id
                this.filterInput.surname = rawData.surname
                this.filterInput.email = rawData.email
                this.filterInput.company_role = rawData.company_role
                this.filterInput.linkedin_url = rawData.linkedin_url
                if (rawData.mobile) {
                    this.filterInput.phone_number = rawData.mobile
                }else if(this.phone){
                    this.filterInput.phone_number = rawData.phone
                }

                if(!rawData.linkedin_url){
                     this.filterInput.linkedin_url = 'https://';
                }
            }else{
                this.externalUserNotFoundShow = true
                this.external_customer_id = ''
                this.filterInput.name = ''
                this.filterInput.external_company_id = ''
                this.filterInput.surname = ''
                this.filterInput.email = ''
                this.filterInput.company_role = ''
                this.filterInput.linkedin_url = ''
                this.filterInput.phone_number = ''
                this.filterInput.linkedin_url = 'https://'
            }
        } catch (error) {
          //console.error("Error fetching customers:", error);
        } finally {
          this.isLoading = false;
        }
      }

      this.isLoading = false;
    },

    async getCompanies() {
        try {
          // this.toggleBusy();
          const response = await Customers.getCompanies()
          this.companyData = response.data.data
        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.companyData = []
        }
    },

    onExternalUserChange(){
        //console.log(this.select_external_user);
        this.external_customer_id = this.select_external_user.external_customer_id
        this.filterInput.name = this.select_external_user.name
        this.filterInput.external_company_id = this.select_external_user.external_company_id
        this.filterInput.surname = this.select_external_user.surname
        this.filterInput.email = this.select_external_user.email
        this.filterInput.company_role = this.select_external_user.company_role
        this.filterInput.linkedin_url = this.select_external_user.linkedin_url
        if (this.select_external_user.mobile) {
            this.filterInput.phone_number = this.select_external_user.mobile
        }else if(this.select_external_user.phone){
            this.filterInput.phone_number = this.select_external_user.phone
        }

        if(!this.select_external_user.linkedin_url){
          this.filterInput.linkedin_url = 'https://';
        }
    },

    selectFile(event) {
      if (this.image) {
        URL.revokeObjectURL(this.image);
      }
      const file = event.target.files[0];
      this.file = file;
      this.image = URL.createObjectURL(file);
    },

    removeImage() {
      this.file = null;
      this.image = "";
      this.$refs['file-input'].reset()
      this.image_removed = true
    },

    selectFileProfileImage(files) {
      setTimeout(() => {
        let queuedFiles = this.$refs.myVueDropzone_profile_url.getQueuedFiles();

        if (queuedFiles.length > 1) {
          this.failedmsg('You can only have one profile image');

          files.forEach((value) => {
            this.$refs.myVueDropzone_profile_url.removeFile(value);
          });
        }
        this.filterInput.image = queuedFiles[0];

        this.photoDeletedCompanyImage = false;
      }, 250);
    },

    async getExternalUsers(){
        this.loadingExternalUsers = true
        try {
            const response = await Customers.getExternalMembers(`accountId=${this.modalData.external_company_id}&exclude_attached=true`)
            this.external_users = response.data.data
            this.loadingExternalUsers = false
        } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.external_users = []
            this.loadingExternalUsers = false
        }
    },

    async addBusinessMember() {

        this.tryingToEdit = true
        this.submitted = true
        this.$v.$touch();

        if (this.$v.$invalid) {
            this.tryingToEdit = false
            return;
        }

        try {
            const data = {
                company_id: this.modalData.company_id,
                external_customer_id: this.external_customer_id,
                name: this.filterInput.name,
                surname: this.filterInput.surname,
                email: this.filterInput.email,
                phone_number: this.filterInput.phone_number,
                profile_url: this.filterInput.image,
                company_role: this.filterInput.company_role,
                linkedin_url: this.filterInput.linkedin_url,
            };

            await Business.addBusinessUsersFromExternalProvider(data);
            this.successmsg("Members has been saved");
            this.closeModal();
            this.refreshData();
        } catch (error) {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.failedmsg(this.error);
        } finally {
            this.tryingToEdit = false;
        }
    },

    resetProps() {
          this.selectedCompany = [],
          this.crm_user = '',
          this.email = '',
          this.name = '',
          this.image = '',
          this.file = '',
          this.company_id = '',
          this.company_role = '',
          this.linkedin_url = '',
          this.image_removed = false,
          this.externalUserData = [],
          // this.companyData = []
          this.filterInput.crm_user = [],
          this.filterInput.email = [],
          this.filterInput.company = [],
          this.filterInput.name = [],
          this.filterInput.image = '',
          this.submitted = false,
          this.external_users = [],
          this.select_external_user = ''
          this.externalUserSearch = ''
    },

    refreshData() {
      this.$emit('onRefresh')
    },

    closeModal() {
      this.showModal = false;
    },

  }


};
</script>
<template>
  <b-modal v-model="showModal" id="add_member_from_external_source" @hidden='resetProps()'  @shown="getExternalUsers()"
           title="Pull Business Members From External Source" title-class="font-18" centered>
    <form @submit.prevent="addBusinessMember">
      <b-form-group>

        <b-form-group label-for="formrow-external-input" class="mb-3">
          <label for="name">Pull user From External Source</label>
          <select v-model="select_external_user" class="form-select" @change="onExternalUserChange">
            <option v-if="loadingExternalUsers" disabled value="">... Loading Users ...</option>
            <option v-else  disabled value="">-- Select a User --</option>
            <option v-for="(external_user, index) in external_users" :key="index" :value="external_user">{{external_user.email}}</option>
          </select>
        </b-form-group>

        <div class="mt-1 text-center">
           OR
        </div>

        <b-form-group label-for="formrow-external-input" class="mb-3">
          <label class="typo__label" for="ajax" >Search (email, ticketing number)</label>
          <vue-bootstrap-typeahead id="formrow-externalUserSearch-input" ref="externalUserSearch"
                               v-model.trim="externalUserSearch"
                               :data=externalUserData
                               />
          <!-- Not Found Message -->
          <!-- Inline Loader (Bootstrap spinner) -->
          <div
              v-if="isLoading"
              class="spinner-border spinner-border-sm text-primary "
          >
            <span class="visually-hidden">Loading...</span>
          </div>
          <div v-if="externalUserNotFoundShow" class="text-danger mt-1">
              No results found.
          </div>
        </b-form-group>

        <hr>
        <label class="typo__label" for="ajax">Company Name</label>
        <b-form-input type="text" v-model="company" :disabled="company != ''"/>

        <label class="typo__label" for="ajax">Name</label>
        <b-form-input type="text" v-model="filterInput.name" :class="{'is-invalid': submitted && $v.filterInput.name.$error}"/>
        <validationMessages v-if="submitted" :fieldName="'Name'"
                            :validationName="$v.filterInput.name"></validationMessages>

        <label class="typo__label" for="ajax">Surname</label>
        <b-form-input type="text" v-model="filterInput.surname" :class="{'is-invalid': submitted && $v.filterInput.surname.$error}"/>
        <validationMessages v-if="submitted" :fieldName="'Surname'"
                            :validationName="$v.filterInput.surname"></validationMessages>

        <label class="typo__label" for="ajax">Email</label>
        <b-form-input type="text" v-model="filterInput.email" :class="{'is-invalid': submitted && $v.filterInput.email.$error}"/>
        <validationMessages v-if="submitted" :fieldName="'Email'"
                            :validationName="$v.filterInput.email"></validationMessages>


        <label class="typo__label" for="ajax">Phone</label>
        <b-form-input type="text" v-model="filterInput.phone_number"/>
        <!--                <validationMessages v-if="submitted" :fieldName="'Phone'" :validationName="$v.filterInput.phone_number"></validationMessages>-->


        <label class="typo__label" for="ajax">Company Role</label>
        <b-form-input type="text" v-model="filterInput.company_role"/>


        <label class="typo__label" for="ajax">LinkeIn URL</label>
        <b-form-input type="text" v-model="filterInput.linkedin_url"/>


        <b-form-group label="Profile Image" label-for="image" class="mb-3 image-area">
          <template>
            <vue-dropzone
                id="profile_url"
                ref="myVueDropzone_profile_url"
                :use-custom-slot="true"
                :options="dropzoneOptions_primary"
                @vdropzone-files-added="selectFileProfileImage"
                no-progress-bar
            >
              <div class="dropzone-custom-content">
                <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                <h4>Drop file here or click to upload.</h4>
              </div>
            </vue-dropzone>
          </template>
        </b-form-group>

      </b-form-group>
      <input type="hidden" name="csrf_token" v-model="csrf_token">
    </form>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="addBusinessMember">
        <b-spinner v-show="tryingToEdit" small></b-spinner>
        Submit
      </b-button>
    </template>
  </b-modal>
</template>
